import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';

export function* raiseHandSaga() {
  logger.remote({ action: true, tier: 1 }).info('The user raised hand');

  yield call(SignalingSocket.send, { event: 'raiseHand' });
}
